import {
  type MatchingColumnFormat,
  type TableColumnHashingAlgorithm,
} from "@decentriq/graphql/dist/types";
import { MediaDataRoomParticipantRole } from "./base";

export const DEFAULT_PARTICIPANTS_EMAILS = new Map<
  MediaDataRoomParticipantRole,
  string[]
>([
  [MediaDataRoomParticipantRole.Publisher, []],
  [MediaDataRoomParticipantRole.DataPartner, []],
  [MediaDataRoomParticipantRole.Advertiser, []],
  [MediaDataRoomParticipantRole.Observer, []],
  [MediaDataRoomParticipantRole.Agency, []],
]);

export interface PublishMediaDataRoomInput {
  dataPartnerEmails: string[];
  advertiserEmails: string[];
  agencyEmails: string[];
  enableInsights: boolean;
  enableLookalike: boolean;
  enableRemarketing: boolean;
  enableRuleBasedAudiences: boolean;
  hideAbsoluteValuesFromInsights: boolean;
  enableAdvertiserAudienceDownload: boolean;
  observerEmails: string[];
  publisherEmails: string[];
  mainAdvertiserEmail: string;
  mainPublisherEmail: string;
  name: string;
  matchingIdFormat: MatchingColumnFormat;
  matchingIdHashingAlgorithm?: TableColumnHashingAlgorithm;
}
